import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  selectVisitDetail,
  selectVisitDetailError,
  selectVisitDetailIsLoading,
  selectVisitDetailNotFound,
  useVisitDetailStore,
} from '@/store/visitDetailSlice';

export function useVisitPage() {
  const { id } = useParams<{ id: string }>();
  const visit = useVisitDetailStore(selectVisitDetail);
  const isLoading = useVisitDetailStore(selectVisitDetailIsLoading);
  const error = useVisitDetailStore(selectVisitDetailError);
  const notFound = useVisitDetailStore(selectVisitDetailNotFound);
  const fetchVisit = useVisitDetailStore((s) => s.fetchVisit);
  const reset = useVisitDetailStore((s) => s.reset);

  useEffect(() => {
    if (id) void fetchVisit(id);
    return () => reset();
  }, [id, fetchVisit, reset]);

  return { visit, isLoading, error, notFound };
}
